import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/ScrollToTop"; 

// Lazy load components
const Home = lazy(() => import("./pages/Home"));
const Licence = lazy(() => import("./pages/Licence"));
const BookingDetail = lazy(() => import("./pages/BookingDetail"));
const Contact = lazy(() => import("./pages/Contact"));
const Booking = lazy(() => import("./pages/Book"));
const NotFound = lazy(() => import("./pages/NotFound"));
const TwoseatBook = lazy(() => import("./pages/TwoseatBook"));
const Books = lazy(() => import("./pages/Boks"));
const About = lazy(() => import("./pages/About"));
const Blogs = lazy(() => import("./pages/Blogs"));
const BlogDetail = lazy(() => import("./pages/BlogDetail"));
const StripeSuccess = lazy(() => import("./pages/StripeSuccess"));
const StripeCancel = lazy(() => import("./pages/StripeCancel"));

const PaypalSuccess = lazy(() => import("./pages/PaypalSuccess"));
const PaypalCancel = lazy(() => import("./pages/PayPalCancel"));
const PrintOrder = lazy(() => import("./pages/PrintOrder"));


// Admin components
const Login = lazy(() => import("./admin/pages/Login"));
const AdminLayout = lazy(() => import("./admin/components/AdminLayout"));
const Dashboard = lazy(() => import("./admin/pages/Dashboard"));
const Bookings = lazy(() => import("./admin/pages/Bookings/Booking"));
const AddBooking = lazy(() => import("./admin/pages/Bookings/AddBooking"));
const EditBooking = lazy(() => import("./admin/pages/Bookings/EditBooking"));
const ContactList = lazy(() => import("./admin/pages/Contact/ContactList"));
const CouponsList = lazy(() => import("./admin/pages/Coupons/CouponsList"));
const AddCoupon = lazy(() => import("./admin/pages/Coupons/AddCoupon"));
const BlogList = lazy(() => import("./admin/pages/Blogs/BlogList"));
const AddBlog = lazy(() => import("./admin/pages/Blogs/AddBlog"));
const EditBlog = lazy(() => import("./admin/pages/Blogs/EditBlog"));
const Backup = lazy(() => import("./admin/pages/Backup/Backup"));
const Vip = lazy(() => import("./admin/pages/Vip/Vip"));
const Inventory = lazy(() => import("./admin/pages/Inventory/Inventory"));
const ProtectedRoute = lazy(() => import("./admin/components/ProtectedRoute"));

// Loading component
const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh',
    fontSize: '1.2rem'
  }}>
    Loading...
  </div>
);

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/driver-license" element={<Licence />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="*" element={<NotFound />} />

            
              <Route path="/two-seater-booking" element={<TwoseatBook />} />
              <Route path="/booking-checking" element={<Books />} />

              <Route path="/booking-shinjuku" element={<BookingDetail />} />



            <Route path="/about" element={<About />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />

            <Route path="/stripe/success/:order_no" element={<StripeSuccess />} />
            <Route path="/stripe/pending/:order_no" element={<StripeCancel />} />
                <Route path="/paypal/success/:order_no" element={<PaypalSuccess />} />
            <Route path="/paypal/pending/:order_no" element={<PaypalCancel />} />
             <Route path="/print/:order_no" element={<PrintOrder />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<Login />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="bookings/add" element={<AddBooking />} />
              <Route path="bookings/edit/:id" element={<EditBooking />} />
              <Route path="contact" element={<ContactList />} />
              <Route path="coupons" element={<CouponsList />} />
              <Route path="coupons/add" element={<AddCoupon />} />
              <Route path="blogs" element={<BlogList />} />
              <Route path="blogs/add" element={<AddBlog />} />
              <Route path="blogs/edit/:id" element={<EditBlog />} />
              <Route path="vip" element={<Vip />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="backup" element={<Backup />} />
              
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;